import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { 
  Box,
  Button,
  Container, 
  TextField, 
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';

import Logo from "../../assets/icons/lusidpay_logo.svg";
import LoadingButton from '../../components/buttons/Button';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import { 
  ForgotPassword, 
  ResetPassword
} from '../../redux/actions/authActions';

import style from "../../global.scss";
import "./styles.scss";

const Data = {
  userName: "",
  otp: "",
  refId: "",
  newPassword: "",
  confirmPassword: ""
}

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);

  const [mode, setMode] = useState(1);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleForgotPassword = () => {
    let obj = {
      email: formData.userName || ""
    };
    dispatch(ForgotPassword(obj, setLoading)).then(({res, statusCode}) => {
      if(statusCode === 200){
        setMode(2);
        setFormData({
          ...formData,
          refId: res.data.ref_id
        });
      };
    })
  };

  const handleChangePassword = () => {
    let obj = {
      ref_id: formData.refId,
      email: formData.userName || "", 
      otp: formData.otp,
      new_password: formData.newPassword,
      confirm_password: formData.confirmPassword
    };

    dispatch(ResetPassword(obj, setLoading)).then(({res, statusCode}) => {
      if(statusCode === 200){
        navigate("/auth");
      }
    });
  };

  return (
    <Box >
      <Box className='auth__top'>
        <Container maxWidth="lg">
          <Box className='flexCenterSBRow'>
            <img
              src={Logo}
              alt="lusid-logo"
              style={{ width: "180px" }}
              />
            <Typography variant='h5' sx={{ color: style["secondary"] }}>
              {"Business"}
            </Typography>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Box className="auth flexCenterCenterRow">
          <Box className="auth__content flexCenterCenterRow" 
            p={"25px"}>
            {
              mode === 1
              ?
              <Box className="flex_CenterColumn" gap={"20px"} width={"360px"}>
                <Typography
                  variant='h6'
                  textAlign={"center"}>
                  Forgot Password?
                </Typography>
                <Typography
                  variant='body2'
                  textAlign={"center"}>
                  Enter your email to receive password reset code.
                </Typography>
                <TextField 
                  variant="outlined"
                  label="Email"
                  name="userName"
                  fullWidth={true}
                  placeholder='Enter your email'
                  value={formData.userName}
                  onChange={handleChange}
                  />
                <LoadingButton
                  variant='contained' 
                  loading={loading}
                  onClick={handleForgotPassword}>
                  Send Reset Code
                </LoadingButton>
                <Button
                  variant='text'
                  onClick={() => navigate("/auth")}>
                  Login
                </Button>
              </Box>
              :
                mode === 2
                ?
                <Box className="flex_CenterColumn" gap={"20px"} width={"360px"}>
                  <Typography
                    variant='h6'
                    textAlign={"center"}>
                    Enter new password
                  </Typography>
                  <TextField 
                    variant="outlined"
                    label="Verification Code"
                    name="otp"
                    fullWidth={true}
                    placeholder='Enter your verification code'
                    value={formData.otp}
                    onChange={handleChange}
                    />
                  <TextField 
                    variant="outlined"
                    label="New password"
                    name="newPassword"
                    type={newPasswordShow ? "text" : "password"}
                    fullWidth={true}
                    placeholder='Enter your new password'
                    value={formData.newPassword}
                    onChange={handleChange}
                    InputProps={{
                      endAdornment: 
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setNewPasswordShow(!newPasswordShow);
                            }}>
                          {
                            newPasswordShow
                            ? <VisibilityOffOutlinedIcon />   
                            : <VisibilityOutlinedIcon />
                          }
                          </IconButton>
                        </InputAdornment>,
                    }}
                    />
                  <TextField 
                    variant="outlined"
                    label="Confirm password"
                    name="confirmPassword"
                    type={confirmPasswordShow ? "text" : "password"}
                    fullWidth={true}
                    placeholder='Enter your new password again'
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    InputProps={{
                      endAdornment: 
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setConfirmPasswordShow(!confirmPasswordShow);
                            }}>
                          {
                            confirmPasswordShow
                            ? <VisibilityOffOutlinedIcon />   
                            : <VisibilityOutlinedIcon />
                          }
                          </IconButton>
                        </InputAdornment>,
                    }}
                    />
                  <LoadingButton
                    variant='contained' 
                    loading={loading}
                    disabled={
                      formData.otp.length !== 6 || 
                      formData.newPassword.length < 8 || 
                      formData.newPassword !== formData.confirmPassword 
                    }
                    onClick={handleChangePassword}>
                    Submit
                  </LoadingButton>
                </Box>
                :
                <></>
            }
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default ForgotPasswordPage;